import axios from 'axios';
import Api from 'redux/api';
import { t } from 'i18next';

export default class ConnectApi extends Api {
  getStoreList = async () => {
    try {
      const apiData = await this.get(`channels/info`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  updateSelectedStore = async (payload, channelName) => {
    try {
      const apiData = await this.put(`linkedAccount/${channelName}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: error?.response?.data?.responseMessage || t('GRAAS_FAIL_TO_UPDATE_CHANNEL_DATA_GRAAS')
      };
    }
  };

  updateCategoryStore = async (payload, channelName) => {
    try {
      const apiData = await this.put(`linkedAccount/${channelName}/syncCategories`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: error?.response?.data?.responseMessage || t('GRAAS_FAIL_TO_SYNCCATEGORIES_DATA_GRAAS')
      };
    }
  };

  getAccountCategories = async path => {
    try {
      const response = await axios.get(path);
      const { data } = response;
      return data;
    } catch (error) {
      return [];
    }
  };

  syncPolicy = async (channelName, payload) => {
    try {
      const apiData = await this.put(`linkedAccount/${channelName}/policies`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: error?.response?.data?.responseMessage || t('GRAAS_FAIL_TO_SYNC_POLICIES_GRAAS')
      };
    }
  };

  getIntegrationErrorMappings = async () => {
    try {
      const apiData = await this.get(`integration/errorMappings`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };
}
